import { render } from "./Menu_movil.vue?vue&type=template&id=95b056a6&scoped=true"
import script from "./Menu_movil.vue?vue&type=script&lang=js"
export * from "./Menu_movil.vue?vue&type=script&lang=js"

import "./Menu_movil.vue?vue&type=style&index=0&id=95b056a6&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b056a6"]])

export default __exports__